import { AfterViewChecked, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import {FormControl} from '@angular/forms';
import {debounceTime, distinctUntilChanged} from 'rxjs';

@Component({
    selector: 'app-auto-search-dropdown',
    templateUrl: './auto-search-dropdown.component.html',
    styleUrl: './auto-search-dropdown.component.scss',
    standalone: false
})
export class AutoSearchDropdownComponent implements OnInit, OnChanges, AfterViewChecked {
  @Input() listData                  : any[];
  @Input() placeholder               : string;
  @Output() selectedValues           = new EventEmitter();
  @Output() searchText               = new EventEmitter();
  @Output() loadMore                 = new EventEmitter();
  @Output() blurred                  = new EventEmitter();
  @Output() fetchSuggested           = new EventEmitter<any>();
  @Input() previousSeletedValues     : any;
  @Input() showEmailIcon             : boolean = false;
  @Input() isMultiSelect             : boolean = true;
  @Input() borderColor               : boolean = false;
  @Input() isDisabled                : boolean = false;
  @Input() showClearIcon             : boolean = false;
  @Input() autoOpen                  : boolean = false;
  @Input() submenuList               : any[] = [];
  @Input() useNameAsId               : boolean = false;
  @Input() returnObject              : boolean = false;
  @Input() suggestedValue            : any;
  @Input() suggestedItem             : any;
  showDropDown                       : boolean = false;
  checkedList                        : any[] = [];
  selectedIDs                        : any[] = [];
  multiSelectedIDs                   : any[] = [];
  checkedMultiList                   : any[] = [];
  multiListData                      : any[] = [];
  searchControl                      : FormControl;
  focusedIndex                       : number = -1;
  isLoadingMore                      : any;
  isLoadingPrevious                  : any;
  selectedObjects                    : any[] = [];
  private shouldFocusInput = false;
  private submenuHoverTimeout: any;
  @ViewChild('dropdownInput') dropdownInput!: ElementRef;
  @ViewChild('dropdownContainer', { static: false }) dropdownContainer: ElementRef;
  dropdownFocusTimeout: any;
  hoveredItem: any = null;
  selectedSubItems: any = {};
  hoveredIndex: number = -1;


  constructor() {
    this.searchControl = new FormControl('');
  }

  ngOnInit(): void {
    if (this.autoOpen) {
      this.showDropdown();
    }
    this.searchControl?.valueChanges.pipe(debounceTime(1000))
    .pipe(distinctUntilChanged()).subscribe((res: any) => {
       this.searchText.emit(this.searchControl.value);
    })
  }

  ngAfterViewChecked() {
    if (this.shouldFocusInput && this.dropdownInput) {
      this.dropdownInput.nativeElement.focus();
      this.shouldFocusInput = false; 
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.handlePreviousSelectedValues(changes);
    this.handleListDataChanges(changes);
    if (!this.isMultiSelect) {
      this.getPreviousSelectedValue();
    }
    this.handleSuggestedValueChanges(changes);
    this.handleSuggestedItemChanges(changes);
  }

  handlePreviousSelectedValues(changes: SimpleChanges) {
    if (changes['previousSeletedValues']) {
      const values = changes['previousSeletedValues'].currentValue || [];
      if (this.isMultiSelect) {
        this.setPreviousMultiSelectedValues(values);
      } else {
        this.selectedIDs = [this.normalizeId(changes['previousSeletedValues'].currentValue)];
      }
    }
  }

  setPreviousMultiSelectedValues(values: any[]) {
    if (this.returnObject && values.length > 0 && typeof values[0] === 'object') {
      this.selectedObjects = [...values];
      this.multiSelectedIDs = values.map((v: any) => this.useNameAsId ? v.name : this.normalizeId(v));
    } else if (Array.isArray(values)) {
      this.multiSelectedIDs = [...values];
    } else if (values) {
      this.multiSelectedIDs = [values];
    } else {
      this.multiSelectedIDs = [];
    }
  }

  handleListDataChanges(changes: SimpleChanges) {
    if (changes['listData'] || changes['previousSeletedValues']) {
      if (this.isMultiSelect) {
        this.updateMultiSelectList();
      } else {
        this.updateSingleSelectList();
      }
      this.multiListData = this.listData;
    }
  }

  updateMultiSelectList() {
    this.checkedMultiList = [];
    this.listData = this.listData?.map((item: any) => {
      const identifier = this.useNameAsId ? item.name : this.normalizeId(item);
      const isChecked = this.multiSelectedIDs?.some(id => id == identifier);
      if (isChecked && !this.checkedMultiList.includes(item.name)) {
        this.checkedMultiList.push(item.name);
      }
      return { ...item, checked: isChecked };
    });
    this.addSubmenuListToChecked();
  }

  addSubmenuListToChecked() {
    if (this.submenuList?.length) {
      this.multiSelectedIDs.forEach(id => {
        if (this.submenuList.includes(id) && !this.checkedMultiList.includes(id)) {
          this.checkedMultiList.push(id);
        }
      });
    }
  }

  updateSingleSelectList() {
    this.checkedList = [];
    this.listData = this.listData?.map((item: any) => {
      const identifier = this.normalizeId(item);
      const isChecked = this.selectedIDs.some(id => id == identifier);
      if (isChecked) {
        this.checkedList = [item.name];
      }
      return { ...item, checked: isChecked };
    });
  }

  handleSuggestedValueChanges(changes: SimpleChanges) {
    if (
      !this.isMultiSelect &&
      (changes['suggestedValue'] || changes['listData'] || changes['previousSeletedValues']) &&
      this.suggestedValue &&
      !this.previousSeletedValues
    ) {
      this.moveSuggestedToTop();
    }
  }

  handleSuggestedItemChanges(changes: SimpleChanges) {
    if (changes['suggestedItem'] && this.suggestedItem && !this.previousSeletedValues) {
      this.prependSuggestedItem(this.suggestedItem);
    }
  }

  getMultiSelectedValue(status: boolean, value: any, isSubItem: boolean = false, parentItem: any = null) {
    const id = (isSubItem || this.useNameAsId) ? value.name : this.normalizeId(value);
    const name = value.name;
    if (status) {
      this.addToSelectedValues(id, name, value);
    } else {
      this.removeFromSelectedValues(id, name, value);
    }
    if (!isSubItem) {
      this.multiselectedList(status, (this.useNameAsId) ? value.name : this.normalizeId(value));
    }
    this.selectedValues.emit(this.returnObject ? this.selectedObjects : this.multiSelectedIDs);
  }

  addToSelectedValues(id: any, name: string, value: any) {
    const idIndex = this.multiSelectedIDs.findIndex(x => x == id);
    if (idIndex === -1) {
      this.multiSelectedIDs.push(id);
    }
    const nameIndex = this.checkedMultiList.indexOf(name);
    if (nameIndex === -1) {
      this.checkedMultiList.push(name);
    }
    if (this.returnObject) {
      const valueId = this.normalizeId(value);
      const objIndex = this.selectedObjects.findIndex(x => this.normalizeId(x) === valueId);
      if (objIndex === -1) {
        this.selectedObjects.push(value);
      }
    }
  }

  removeFromSelectedValues(id: any, name: string, value: any) {
    const idIndex = this.multiSelectedIDs.findIndex(x => x == id);
    if (idIndex > -1) {
      this.multiSelectedIDs.splice(idIndex, 1);
    }
    const nameIndex = this.checkedMultiList.indexOf(name);
    if (nameIndex > -1) {
      this.checkedMultiList.splice(nameIndex, 1);
    }
    if (this.returnObject) {
      const valId = this.normalizeId(value);
      const objIndex = this.selectedObjects.findIndex(x => this.normalizeId(x) == valId);
      if (objIndex > -1) {
        this.selectedObjects.splice(objIndex, 1);
      }
    }
  }

  singleSelectedValue(value: any) {
    const id = this.normalizeId(value);
    this.previousSeletedValues = value.name;
    this.selectedIDs = [id];
    this.checkedList = [value.name];
    this.singleSelectedList(id);
    this.selectedValues.emit(value);
    this.showDropDown = false;
  }

  singleSelectedList(id: any) {
    const update = (x: any) => {
      if (this.normalizeId(x) == id) {
        return { ...x, checked: true };
      } else {
        return { ...x, checked: false };
      }
    };
    this.listData = this.listData?.map(update);
    this.multiListData = this.multiListData?.map(update);
  }

  multiselectedList(status: boolean, id: any) {
    if (id === null || id === undefined) return;
    const update = (x: any) => {
      const identifier = this.useNameAsId ? x.name : this.normalizeId(x);
      if (identifier == id) {
        return { ...x, checked: status };
      }
      return x;
    };
    this.listData = this.listData?.map(update);
    this.multiListData = this.multiListData?.map(update);
  }

  handleFilter(event: any) {
    this.multiListData = this.listData.filter((s: any) => s.name.toLowerCase().includes(event.target.value.toLowerCase()));
  }

  showDropdown() {
    this.multiListData = this.listData;
    this.showDropDown = !this.showDropDown;
    this.shouldFocusInput = true;
    if (this.showDropDown) {
      this.searchControl.setValue('');
      this.multiListData = this.listData;
      this.focusedIndex = -1;
    }
  }

  addItem(newEmail: any) {
    if (newEmail) {
      this.showEmailIcon = true;
      const newItem = { _id: newEmail, name: newEmail, checked: true };
      this.listData.push(newItem);
      this.multiSelectedIDs.push({emailAddress: newEmail});
      this.checkedMultiList.push(newEmail);
      if (this.returnObject) {
        this.selectedObjects.push(newItem);
      }
      this.selectedValues.emit(this.returnObject ? this.selectedObjects : this.multiSelectedIDs);
      this.showEmailIcon = false;
      this.listData = [...this.listData];
      this.searchControl.setValue('');
      this.multiListData = this.listData;
      this.searchControl.reset();
    }
  }

  onDropdownScroll(event: any) {
    if (this.searchControl.value?.trim()) return;
    const scrollTop = event.target.scrollTop;
    const scrollHeight = event.target.scrollHeight;
    const clientHeight = event.target.clientHeight;
    if (scrollHeight - scrollTop <= clientHeight + 5) {
      this.loadMore.emit();
    }
  }

  onKeyDown(event: KeyboardEvent) {
    if (!this.multiListData || this.multiListData.length === 0) return;
    const isFiltered = this.searchControl.value?.trim().length > 0;
    switch (event.key) {
      case 'ArrowDown':
        this.handleArrowDown(isFiltered);
        event.preventDefault();
        break;
      case 'ArrowUp':
        this.handleArrowUp(isFiltered);
        event.preventDefault();
        break;
      case 'Enter':
        this.handleEnter();
        event.preventDefault();
        break;
    }
  }

  handleArrowDown(isFiltered: boolean): void {
    if (this.focusedIndex < this.multiListData.length - 1) {
      this.focusedIndex++;
      this.scrollFocusedItemIntoView();
    } else if (!isFiltered && !this.isLoadingMore) {
      this.loadMoreAndFocusNext('bottom');
    }
  }

  handleArrowUp(isFiltered: boolean): void {
    if (this.focusedIndex > 0) {
      this.focusedIndex--;
      this.scrollFocusedItemIntoView();
    } else if (!isFiltered && !this.isLoadingPrevious) {
      this.loadMoreAndFocusNext('top');
    }
  }

  loadMoreAndFocusNext(direction: 'top' | 'bottom'): void {
    const isBottom = direction === 'bottom';
    const loadingFlag = isBottom ? 'isLoadingMore' : 'isLoadingPrevious';
    this[loadingFlag] = true;
    this.loadMore.emit();
    setTimeout(() => {
      if (isBottom) {
        this.scrollDropdownToBottom();
        this.focusedIndex++;
      } else {
        this.scrollDropdownToTop();
        this.focusedIndex = 0;
      }
      this.scrollFocusedItemIntoView();
      this[loadingFlag] = false;
    }, 300);
  }

  handleEnter(): void {
    if (this.focusedIndex < 0 || this.focusedIndex >= this.multiListData.length) return;
    if (this.isMultiSelect) {
      const item = this.multiListData[this.focusedIndex];
      this.getMultiSelectedValue(!item.checked, item);
    } else {
      this.singleSelectedValue(this.multiListData[this.focusedIndex]);
      this.focusedIndex = -1;
    }
  }

  scrollDropdownToBottom() {
    const el = this.dropdownContainer?.nativeElement;
    if (el) {
      el.scrollTop = el.scrollHeight;
    }
  }

  scrollDropdownToTop() {
    const el = this.dropdownContainer?.nativeElement;
    if (el) {
      el.scrollTop = 0;
    }
  }

  scrollFocusedItemIntoView() {
    const container = this.dropdownContainer?.nativeElement;
    if (container) {
      const labels = container.querySelectorAll('label');
      if (labels[this.focusedIndex]) {
        (labels[this.focusedIndex] as HTMLElement).scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
        });
      }
    }
  }

  onDropdownFocusIn() {
    clearTimeout(this.dropdownFocusTimeout);
  }

  onDropdownFocusOut() {
    this.dropdownFocusTimeout = setTimeout(() => {
      this.showDropDown = false;
      this.blurred.emit();
    }, 200);
  }

  clearSelection(event: any) {
    this.previousSeletedValues = null;
    this.selectedIDs = [];
    this.checkedList = [];
    this.multiSelectedIDs = [];
    this.checkedMultiList = [];
    this.selectedObjects = [];
    this.selectedSubItems = {};
    this.listData = this.listData?.map(item => ({ ...item, checked: false }));
    this.multiListData = this.listData;
    this.selectedValues.emit(null);
  }

  getPreviousSelectedValue() {
    if (!this.previousSeletedValues || !this.listData) return;
    const list = Array.isArray(this.listData) ? this.listData : [];
    const normalizeId = (v: any) => {
      if (v == null) return null;
      if (typeof v === 'object') return v._id ?? v.id ?? v;
      return v;
    };
    const prev = this.previousSeletedValues;
    const prevId = normalizeId(prev);
    if (!prevId) return;
    const existsIndex = list.findIndex((item: any) => (item._id ?? item.id ?? item.name) === prevId || item.name === prevId);
    if (existsIndex > -1) {
      const [item] = list.splice(existsIndex, 1);
      item.checked = true;
      list.unshift(item);
    }
    if (!this.isMultiSelect) {
      for (let i = 1; i < list.length; i++) {
        list[i] = { ...list[i], checked: false };
      }
    }
    const seen = new Set();
    const deduped: any[] = [];
    for (const it of list) {
      const key = it._id ?? it.id ?? it.name;
      if (!seen.has(key)) {
        seen.add(key);
        deduped.push(it);
      }
    }
    this.listData = deduped;
    this.multiListData = deduped;
  }

  onItemMouseEnter(item: any, index: number) {
    if (this.submenuHoverTimeout) {
      clearTimeout(this.submenuHoverTimeout);
      this.submenuHoverTimeout = null;
    }
    this.hoveredItem = item;
    this.hoveredIndex = index;
  }

  onItemMouseLeave() {
    this.submenuHoverTimeout = setTimeout(() => {
      this.hoveredItem = null;
      this.hoveredIndex = -1;
    }, 200);
  }

  onSubmenuMouseEnter() {
    if (this.submenuHoverTimeout) {
      clearTimeout(this.submenuHoverTimeout);
      this.submenuHoverTimeout = null;
    }
  }

  isSubItemChecked(parentItem: any, subItem: string): boolean {
    return this.multiSelectedIDs.some(id => id == subItem);
  }

  
  normalizeId(v: any): any {
    if (v == null) return null;
    if (typeof v === 'object') return v._id || v.id || v.name || v;
    return v;
  }

  moveSuggestedToTop() {
    if (!this.suggestedValue) return;
    const isObject = typeof this.suggestedValue === 'object' && this.suggestedValue !== null;
    const suggestedId = isObject ? this.normalizeId(this.suggestedValue) : this.suggestedValue;
    const suggestedName = isObject ? this.suggestedValue?.name : this.suggestedValue;
    const list = Array.isArray(this.listData) ? [...this.listData] : [];
    const existsIndex = list.findIndex(
      (item: any) =>
        (item._id ?? item.id ?? item.name) === suggestedId ||
        item.name === suggestedName
    );
    if (existsIndex > 0) {
      const [item] = list.splice(existsIndex, 1);
      list.unshift({ ...item, checked: false });
      this.listData = list;
      this.multiListData = list;
    } else if (existsIndex === -1 && isObject) {   
      list.unshift({ ...this.suggestedValue, checked: false });
      this.listData = list;
      this.multiListData = list;
    } else if (existsIndex === -1 && !isObject) {
      this.fetchSuggested.emit(this.suggestedValue);
    }
  }

  prependSuggestedItem(item: any) {
    if (!item || !this.listData) return;
    const itemId = this.normalizeId(item);
    const exists = this.listData.some(
      (x: any) => this.normalizeId(x) === itemId || x.name === item.name
    );
    if (!exists) {
      const list = [{ ...item, checked: false }, ...this.listData];
      this.listData = list;
      this.multiListData = list;
    }
  }

}
